import { motion } from "framer-motion";

const groupOrder = ["Mentorship", "Classes", "Production"];

export const RateCard = ({ services, onSelect }) => {
  const paid = services.filter((s) => s.paid);
  const groups = groupOrder
    .map((g) => ({ name: g, items: paid.filter((s) => s.category === g) }))
    .filter((g) => g.items.length);

  return (
    <section id="rates" data-testid="rates-section" className="py-28 sm:py-40 bg-[#050505]">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <div className="mb-16">
          <p className="font-body text-xs uppercase tracking-[0.3em] text-gray-500 mb-4">Industry Rates</p>
          <h2 className="font-head uppercase text-4xl sm:text-6xl tracking-tighter text-white leading-none">
            Rate Card<span className="text-[#D90429]">.</span>
          </h2>
        </div>

        <div className="space-y-16">
          {groups.map((group) => (
            <div key={group.name}>
              <h3 className="font-serif-italic text-2xl text-[#EF233C] mb-6">{group.name}</h3>
              <div className="divide-y divide-white/10 border-t border-white/10">
                {group.items.map((s, i) => (
                  <motion.div
                    key={s.id}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: i * 0.05 }}
                    data-testid={`rate-row-${s.id}`}
                    className="group grid grid-cols-12 items-center gap-4 py-7 hover:bg-white/[0.03] transition-colors duration-300 px-2"
                  >
                    <div className="col-span-12 sm:col-span-6">
                      <h4 className="font-head uppercase text-2xl sm:text-3xl tracking-tight text-white">{s.name}</h4>
                      <p className="font-body text-sm text-gray-400 mt-1 max-w-md">{s.description}</p>
                    </div>
                    <div className="col-span-6 sm:col-span-3">
                      <span className="font-body text-xs uppercase tracking-[0.2em] text-gray-500">{s.duration}</span>
                    </div>
                    <div className="col-span-6 sm:col-span-3 flex items-center justify-end gap-6">
                      <span className="font-head text-3xl text-white">${s.price.toFixed(0)}</span>
                      <button
                        data-testid={`rate-book-${s.id}`}
                        onClick={() => onSelect(s.id)}
                        className="shrink-0 px-5 py-2.5 border border-white/20 text-white text-xs uppercase tracking-[0.15em] hover:bg-[#D90429] hover:border-[#D90429] transition-colors duration-300"
                      >
                        Book
                      </button>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
